import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import * as API from '../../../shared/core/utils/auth-utils';
import {   TokenResponse, HttpError} from '../../../shared/core/models';

const initialState = {
  isLoading: false,
  error: '',
  step: 0,
  showOTP: false,

};

/**
 * Thunks Actions
 */
const signup = createAsyncThunk<any, any, any>(
  'signup/post',
  async (request: any, thunkAPI) => {
    starLoading()
    const response: any = await API.getAuthToken(request);
    if (response.status === 400) {
      return thunkAPI.rejectWithValue((await response.json()) as HttpError);
    }

    const tokenResponse = await response.json();
    onSignupSuccess(tokenResponse);
    endLoading()
    return tokenResponse;
  },
);

/**
 * Reducers
 */
const signupReducer = createSlice({
  name: 'signup',
  initialState: initialState,
  reducers: {
    changeStep(state: any, action:any) {
      state.step = action.payload;
    },
    onSignupSuccess(state) {

      //state.token = payload.token;
    },
    starLoading(state) {
      state.isLoading = true;
    },
    endLoading(state) {
      state.isLoading = false;
    },
    setShowOTP(state,action: any) {
      state.showOTP = action.payload;
    },

    setUser(state: any, action : any) {
      state.user={...state.user, ...(action.payload|| {}) }
    },

    resetSignup(state: any, _action : any){
      state.user={}
    }

  },
  extraReducers: (builder) => {
    builder.addCase(
      signup.fulfilled,
      (state, {payload}: PayloadAction<TokenResponse>) => {
         state.isLoading = true;

      },
    );
    builder.addCase(signup.rejected, (state:any, action) => {
      state.isLoading = false;
      if (action.payload) {
        state.error = action.error;
      }
    });
  },
});

/*Actions export*/
const {
  onSignupSuccess,
  starLoading,
  endLoading,
  changeStep,
  setShowOTP,
  setUser,
  resetSignup
} = signupReducer.actions;
export {
  signup,
  onSignupSuccess,
  starLoading,
  endLoading,
  changeStep,
  setShowOTP,
  setUser,
  resetSignup
};
/*Reducer export*/
export default signupReducer;
